module.exports = __webpack_public_path__ + "img/pr-3.b6ee6331.png";